import React from 'react'
import './Common.css';

const Header = () => {
  return (
    <h1 style={{  textAlign: 'center',fontSize: '100px', color: '#2c3e50',fontWeight:'200'}}>TodoList</h1>
  )
}

export default Header